import { getEnvVariable } from '@/utils';

export const PENDO_API_KEY = getEnvVariable('REACT_APP_PENDO_API_KEY', '');
